
    import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
    import localizeDate from '@/app/common/helpers/localize-date'
    import moment from 'moment'
    import validation from '@/app/common/helpers/validation'

    @Component
    export default class DatePicker extends Vue {
        @Prop({ type: String }) readonly value!: string|null
        @Prop({ type: Boolean, default: false }) readonly solo!: boolean
        @Prop({ type: String }) readonly label!: string|null
        @Prop({ type: Boolean, default: false }) readonly noIcon!: boolean
        @Prop({ type: Boolean, default: true }) readonly clearable!: boolean
        @Prop({ default: false }) readonly hideDetails!: boolean|'auto'
        @Prop() readonly rules!: any[]
        @Prop({ type: String }) readonly maxDate!: string|null
        @Prop({ type: String, default: '1900-01-01' }) readonly minDate!: string|null
        @Prop({ type: String, default: 'DD-MM-YYYY' }) readonly placeholder!: string

        menu = false
        date: string|null = null
        inputValue: string|null = null
        isFromDatePicker = false

        @Watch('value')
        watchValue(value: string) {
            if (value !== this.date) {
                this.date = value
            }
        }

        @Watch('date')
        watchDate(value: string) {
            if (this.isFromDatePicker) {
                this.inputValue = value ? localizeDate(value) : null
            }
            this.$emit('input', value)
        }

        mounted() {
            this.date = this.value
            this.inputValue = this.value ? localizeDate(this.value) : null
        }

        onManualInput(value: string) {
            this.isFromDatePicker = false
            if (value) {
                const parsed = moment(value, 'DD-MM-YYYY', true)
                if (parsed.isValid()) {
                    this.date = parsed.format('YYYY-MM-DD')
                }
            } else {
                this.date = null
            }
        }

        onBlur() {
            if (this.date) {
                this.inputValue = localizeDate(this.date)
            }
        }

        onDateSelect(value: string) {
            this.isFromDatePicker = true
            this.menu = false
            this.date = value
        }

        get combinedRules() {
            const baseRules = this.rules || []
            const dateFormatRule = validation.dateFormat()
            const dateMinRule = validation.dateMin(this.minDate)

            return [...baseRules, dateFormatRule, dateMinRule]
        }

        getIcon() {
            return this.noIcon ? undefined : 'fal fa-calendar-day'
        }
    }
